import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { messageSchema } from './schemas/message-schema';
import {
  VehicleGroup,
  vehicleGroupsSchema,
} from './schemas/vehicle-group.schema';

export function postVehicleGroups(vehicleGroups: Partial<VehicleGroup>[]) {
  return fromFetch(
    new Request(fleetEnvironment.vehicleGroupsUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify(vehicleGroups),
    })
  ).pipe(
    selectData(
      messageSchema.extend({
        data: vehicleGroupsSchema,
      })
    )
  );
}
